<template>
  <div>
    <b-jumbotron bg-variant="dark" border-variant="dark">
      <b-container>
        <b-row>
          <b-col cols="1">
            <img
              style="margin-top: 30px"
              src="../../assets/logo.png"
              width="100"
              height="100"
            />
          </b-col>
          <b-col cols="5">
            <b-row style="padding: 40px 0 10px 40px; font-size: 1.2rem">{{
              about_info.name
            }}</b-row>
            <b-row class="contact_info">
              地址: {{ about_info.address }}
              <span>|</span>
              邮编: {{ about_info.postcode }}
            </b-row>
            <b-row class="contact_info">
              电话: {{ about_info.phone }}
              <span>|</span>
              邮箱: {{ about_info.email }}
            </b-row>
          </b-col>
          <b-col offset="2" cols="2">
            <b-row>
              <h6>友情链接</h6>
            </b-row>
            <b-row
              v-for="(value, index) in external_links_1"
              v-bind:key="index"
            >
              <div class="external-link">
                <a :href="value.link" target="_blank">{{ value.name }}</a>
              </div>
            </b-row>
          </b-col>
          <b-col cols="2">
            <b-row> </b-row>
            <b-row
              v-for="(value, index) in external_links_2"
              v-bind:key="index"
            >
              <div class="external-link">
                <a :href="value.link" target="_blank">{{ value.name }}</a>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <hr class="my-4" />
      <b-container>
        <b-row>
          <b-col class="copyright">版权所有 © {{ about_info.name }}</b-col>
        </b-row>
      </b-container>
    </b-jumbotron>
  </div>
</template>
<script>
export default {
  data() {
    return {
      about_info: "",
      external_links_1: [],
      external_links_2: [],
    };
  },
  created: function () {
    this.get_about_info();
    this.get_external_links();
  },
  methods: {
    get_about_info() {
      let url = "about/info";
      this.$http.get(url).then((response) => {
        this.about_info = response.data[0];
      });
    },
    get_external_links() {
      let url = "about/external-links/?ordering=index";
      this.$http.get(url).then((response) => {
        this.external_links_1 = response.data.slice(0, 4);
        this.external_links_2 = response.data.slice(4, 9);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.jumbotron {
  min-width: 1300px;
  font-size: 16px;
  color: #e2e2e2;
  .container {
    min-width: 1300px;
  }
  a {
    font-size: 16px;
    color: #e2e2e2;
    font-weight: bold !important;
    :hover {
      color: #e2e2e2 !important;
      text-decoration: underline;
    }
  }
  margin: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 0;
  h1 {
    font-size: 25px;
    padding: 0;
    margin: 0;
  }
  .col-3,
  .col-2 {
    .row {
      height: 30px;
      display: block;
    }
  }
  span {
    padding-left: 5px;
  }
  hr {
    border-top: 1px solid gray;
  }
  .contact_info {
    padding-left: 40px;
    padding-bottom: 5px;
    font-size: 13px;
    span {
      color: #ccc;
      font-weight: bold;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  .copyright {
    font-size: 13px;
    text-align: center;
  }
  .external-link {
    a {
      font-size: 13px;
      color: #e2e2e2;
      font-weight: bold !important;
      :hover {
        color: #e2e2e2 !important;
        text-decoration: underline;
      }
    }
  }
}
</style>
